import { useIsInsideContainer } from '@vk-hr-tek/ui/hooks';

/**
 * Определить, что приложение встроено в сторонний сервис как виджет
 */
export const useIsWidget = useIsInsideContainer;
